/*
 * Vergrootglas voor de beelden in de inhoudspagina's en de blog.
 *
 * WAAROM EIGEN CODE. Prestige heeft wel een vergrootglas, maar dat zit vast aan
 * de productgalerij: het werkt op `product-gallery` met media die uit Liquid
 * komt. De beelden in een pagina of blogartikel zitten in vrije HTML en komen
 * daar niet in terecht. Dit is de kleinste eigen oplossing die hetzelfde doet.
 *
 * Wat het doet: klik op een beeld en het opent groot in een laag erboven, met
 * pijltjes als er meer beelden in dezelfde rij staan. Sluiten met Escape, met
 * een klik ernaast of met de knop.
 *
 * Toegankelijkheid: de laag krijgt focus, Tab blijft erin hangen zolang hij open
 * is, en de knoppen dragen een label. Bij `prefers-reduced-motion` valt de
 * overgang weg.
 */

(() => {
  /*
 * Nadrukkelijk NIET de partnerlogo's. Die vergroten levert een uitvergroot
 * logo op een navy vlak op, en daar heeft niemand iets aan.
 */
const SELECTOR = ".fd-page img, .shopify-section--main-article .prose img";
const OVERSLAAN = ".fd-grid--logos img";

  function bouwLaag() {
    const laag = document.createElement("div");
    laag.className = "fd-lightbox";
    laag.setAttribute("role", "dialog");
    laag.setAttribute("aria-modal", "true");
    laag.setAttribute("aria-label", "Afbeelding vergroot");
    laag.hidden = true;
    laag.innerHTML =
      '<button class="fd-lightbox__sluit" type="button" aria-label="Sluiten">&times;</button>' +
      '<button class="fd-lightbox__vorige" type="button" aria-label="Vorige afbeelding">&#8249;</button>' +
      '<figure class="fd-lightbox__doos"><img alt=""><figcaption class="fd-lightbox__teller"></figcaption></figure>' +
      '<button class="fd-lightbox__volgende" type="button" aria-label="Volgende afbeelding">&#8250;</button>';
    document.body.appendChild(laag);
    return laag;
  }

  const beelden = [...document.querySelectorAll(SELECTOR)]
    .filter((i) => i.naturalWidth !== 1 && !i.closest("a") && !i.matches(OVERSLAAN));
  if (!beelden.length) return;

  const laag = bouwLaag();
  const doel = laag.querySelector("img");
  const teller = laag.querySelector(".fd-lightbox__teller");
  const knopVorige = laag.querySelector(".fd-lightbox__vorige");
  const knopVolgende = laag.querySelector(".fd-lightbox__volgende");
  let reeks = [];
  let plek = 0;
  let vanwaar = null;

  /* De reeks is de rij waarin het beeld staat, of alle beelden op de pagina. */
  const reeksVan = (img) => {
    const rij = img.closest(".fd-grid");
    return rij ? [...rij.querySelectorAll("img")] : beelden;
  };

  function toon(n) {
    plek = (n + reeks.length) % reeks.length;
    const bron = reeks[plek];
    /* `src` EERST, niet `currentSrc`. Sinds 02-09 dragen de beelden in de inhoud
       een srcset, en dan is `currentSrc` de variant die de browser voor de PAGINA
       koos, meestal 800px breed. Die in het vergrootglas tonen levert een kleiner
       beeld dan het origineel, wat precies het omgekeerde is van de bedoeling.
       `src` blijft naar het volledige bestand wijzen. */
    doel.src = bron.getAttribute("src") || bron.currentSrc;
    doel.alt = bron.alt || "";
    const meer = reeks.length > 1;
    teller.textContent = meer ? `${plek + 1} van ${reeks.length}` : "";
    knopVorige.hidden = !meer;
    knopVolgende.hidden = !meer;
  }

  function open(img) {
    vanwaar = img;
    reeks = reeksVan(img);
    toon(reeks.indexOf(img));
    laag.hidden = false;
    document.body.style.overflow = "hidden";
    laag.querySelector(".fd-lightbox__sluit").focus();
  }

  function sluit() {
    laag.hidden = true;
    document.body.style.overflow = "";
    if (vanwaar) vanwaar.focus?.();
  }

  for (const img of beelden) {
    img.tabIndex = 0;
    img.setAttribute("role", "button");

    /* Hier stond `if (!img.alt) img.alt = "Vergroot deze afbeelding";` en dat was
       fout. De audit van 02-09 vond het terug op 49 van de 53 beelden in de
       blogartikels, want 50 daarvan hebben alt="" in de bron.
       Een LEGE alt zegt tegen een schermlezer "decoratief, sla over". Die
       overschrijven met een instructie maakt het erger: dan hoort iemand vijftig
       keer dezelfde zin die niets over het beeld zegt, en is de echte alt weg
       zodra die ooit wel ingevuld wordt.
       Het beeld heeft wel een naam NODIG, want het draagt role="button" en een
       bedieningselement zonder naam faalt WCAG 4.1.2. Bij role="button" komt die
       naam uit aria-label, niet uit alt, dus zetten we hem daar en laten we de alt
       met rust. */
    const beschrijving = (img.getAttribute("alt") || "").trim();
    img.setAttribute("aria-label", beschrijving || "Afbeelding vergroten");
    img.addEventListener("click", () => open(img));
    img.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(img); }
    });
  }

  laag.addEventListener("click", (e) => {
    if (e.target === laag || e.target.closest(".fd-lightbox__sluit")) return sluit();
    if (e.target.closest(".fd-lightbox__vorige")) return toon(plek - 1);
    if (e.target.closest(".fd-lightbox__volgende")) return toon(plek + 1);
  });

  document.addEventListener("keydown", (e) => {
    if (laag.hidden) return;
    if (e.key === "Escape") sluit();
    if (e.key === "ArrowLeft") toon(plek - 1);
    if (e.key === "ArrowRight") toon(plek + 1);
    if (e.key === "Tab") {
      // focus binnen de laag houden zolang hij open is
      const knoppen = [...laag.querySelectorAll("button:not([hidden])")];
      const i = knoppen.indexOf(document.activeElement);
      e.preventDefault();
      knoppen[(i + (e.shiftKey ? -1 : 1) + knoppen.length) % knoppen.length].focus();
    }
  });
})();

/* Footer-kaart (feedback Thibaud 10-09-2026). Het iframe van Google Maps komt er pas als de
   footer tot op 200px van het beeld is, zodat een bezoeker die nooit naar onder scrolt Google Maps
   ook niet binnenhaalt. Zonder IntersectionObserver laadt hij meteen. */
(function () {
  var kaarten = document.querySelectorAll('.fd-footer-kaart[data-src]');
  if (!kaarten.length) return;
  function laad(el) {
    var f = document.createElement('iframe');
    f.src = el.dataset.src;
    f.title = el.dataset.titel || 'Kaart';
    f.loading = 'lazy';
    f.referrerPolicy = 'no-referrer-when-downgrade';
    f.allowFullscreen = true;
    el.appendChild(f);
    el.removeAttribute('data-src');
  }
  if (!('IntersectionObserver' in window)) { kaarten.forEach(laad); return; }
  var waarnemer = new IntersectionObserver(function (rijen) {
    rijen.forEach(function (rij) { if (rij.isIntersecting) { waarnemer.unobserve(rij.target); laad(rij.target); } });
  }, { rootMargin: '200px' });
  kaarten.forEach(function (k) { waarnemer.observe(k); });
})();
